import React from "react";

const Bulbasaur = () => ( 
  <img className="Bulbasaur" src="/bulbasaur_walking.gif"></img>
);

export default Bulbasaur;
